import { SCHEDULE_VIEW_MODE } from '../../components/ProviderCalendar/constants';
import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'schedule/validate';

export const SCHEDULE_VALIDATE_TYPES = {
  VALIDATE: `${actionsScope}/validate`,
  VALIDATE_FINISH: `${actionsScope}/validate-finish`,
  TOGGLE_OVERLAP_MODAL: `${actionsScope}/toggle-overlap-modal`,
  TOGGLE_OVERLAP_APPOINTMENT: `${actionsScope}/toggle-overlap-appointment`,
  TOGGLE_RECURSION_MODAL: `${actionsScope}/toggle-recursion-modal`,
  APPLY_RECURSION: `${actionsScope}/apply-recursion`,
  FORCE_OVERLAP: `${actionsScope}/force-overlap`,
  REMOVE_SCHEDULE: `${actionsScope}/remove-schedule`,
  EDIT_WORK_RECURSION: `${actionsScope}/edit-work-recursion`,
  EDIT_BLOCK_RECURSION: `${actionsScope}/edit-block-recursion`,
  TOGGLE_VIEW_MODE: `${actionsScope}/toggle-view-mode`,
  CLEAR: `${actionsScope}/clear`,
};
export const scheduleValidateActions = {
  validate: createAction(SCHEDULE_VALIDATE_TYPES.VALIDATE),
  finishValidate: createAction(SCHEDULE_VALIDATE_TYPES.VALIDATE_FINISH),
  toggleOverlapModal: createAction(
    SCHEDULE_VALIDATE_TYPES.TOGGLE_OVERLAP_MODAL,
  ),
  toggleOverlapAppointment: createAction(
    SCHEDULE_VALIDATE_TYPES.TOGGLE_OVERLAP_APPOINTMENT,
  ),
  toggleRecursionModal: createAction(
    SCHEDULE_VALIDATE_TYPES.TOGGLE_RECURSION_MODAL,
  ),
  applyRecursion: createAction(SCHEDULE_VALIDATE_TYPES.APPLY_RECURSION),
  forceOverlap: createAction(SCHEDULE_VALIDATE_TYPES.FORCE_OVERLAP),
  removeSchedule: createAction(SCHEDULE_VALIDATE_TYPES.REMOVE_SCHEDULE),
  editWorkRecursion: createAction(SCHEDULE_VALIDATE_TYPES.EDIT_WORK_RECURSION),
  editBlockRecursion: createAction(
    SCHEDULE_VALIDATE_TYPES.EDIT_BLOCK_RECURSION,
  ),
  toggleViewMode: createAction(SCHEDULE_VALIDATE_TYPES.TOGGLE_VIEW_MODE),
  clear: createAction(SCHEDULE_VALIDATE_TYPES.CLEAR),
};

const initialState = {
  validating: true,
  viewMode: SCHEDULE_VIEW_MODE.READ,
  userId: null,
  providerId: null,
  overlapModal: false,
  overlapAppointment: false,
  scheduleAdmin: false,
  recursionModal: {},
};

export default function validate(state = initialState, { type, payload }) {
  switch (type) {
    case SCHEDULE_VALIDATE_TYPES.VALIDATE: {
      return { ...state, validating: true };
    }

    case SCHEDULE_VALIDATE_TYPES.VALIDATE_FINISH: {
      const { id, providerId, scheduleAdmin } = payload;
      return {
        ...state,
        userId: id,
        providerId,
        scheduleAdmin,
        validating: false,
      };
    }

    case SCHEDULE_VALIDATE_TYPES.TOGGLE_OVERLAP_MODAL: {
      return { ...state, overlapModal: payload };
    }

    case SCHEDULE_VALIDATE_TYPES.TOGGLE_OVERLAP_APPOINTMENT: {
      return { ...state, overlapAppointment: payload };
    }

    case SCHEDULE_VALIDATE_TYPES.TOGGLE_RECURSION_MODAL: {
      return { ...state, recursionModal: payload };
    }

    case SCHEDULE_VALIDATE_TYPES.TOGGLE_VIEW_MODE: {
      return { ...state, viewMode: payload };
    }

    case SCHEDULE_VALIDATE_TYPES.CLEAR: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/schedule/validate.js